import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SocialUserApp.css';
import { 
    FaCog, FaKeyboard, FaMusic, FaGamepad, FaUser, FaWarehouse, 
    FaLayerGroup, FaUsers, FaChartBar, FaQuestionCircle, FaSignOutAlt,
    FaDiceFive, FaFileInvoiceDollar, FaWrench, FaWallet
} from 'react-icons/fa';
import LiberiumLink from "./LiberiumLink";
import { useNavigate } from "./Router";

const SocialUserApp = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState({ user_id: 0 });
    const [linkClicks, setLinkClicks] = useState([]);
    const [balance, setBalance] = useState(0);
    const [loadingBalance, setLoadingBalance] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("liberium-token");
        if (token) {
            const mine = localStorage.getItem("myself");
            if (mine) setUser(JSON.parse(mine));
        }

        // Charger les données des clics de localStorage
        const storedClicks = JSON.parse(localStorage.getItem("linkClicks")) || {};
        const sortedClicks = Object.entries(storedClicks)
            .sort(([, a], [, b]) => b - a) // Trier par nombre de clics décroissant
            .map(([href]) => href);
        setLinkClicks(sortedClicks);
    }, []);

    // Charger le solde de l'utilisateur
    useEffect(() => {
        const fetchBalance = async () => {
            try {
                setLoadingBalance(true);
                const balanceResponse = await sdk.models.PeupleUser.getAccountBalance();
                if (balanceResponse && typeof balanceResponse.balance !== 'undefined') {
                    setBalance(parseFloat(balanceResponse.balance));
                }
            } catch (err) {
                console.error("Erreur lors de la récupération du solde:", err);
                setBalance(0);
            } finally {
                setLoadingBalance(false);
            }
        };

        if (user.user_id > 0) {
            fetchBalance();
        }
    }, [user.user_id]);

    const recordClick = (href) => {
        const storedClicks = JSON.parse(localStorage.getItem("linkClicks")) || {};
        storedClicks[href] = (storedClicks[href] || 0) + 1; // Incrémenter le compteur
        localStorage.setItem("linkClicks", JSON.stringify(storedClicks));

        // Recalculer et trier
        const sortedClicks = Object.entries(storedClicks)
            .sort(([, a], [, b]) => b - a)
            .map(([href]) => href);
        setLinkClicks(sortedClicks);
    };

    const deconnect = () => {
        localStorage.removeItem("liberium-token");
        localStorage.removeItem("accessToken");
        navigate("/");
    };

    const links = [
        { href: `/user/${user.user_id}`, icon: FaUser, label: "Ma page", condition: user.user_id !== 0 },
        { href: "/profile", icon: FaUsers, label: "Mon profil" },
        { href: "/settings", icon: FaWrench, label: "Paramètres" },
        { href: "/portefeuille", icon: FaWallet, label: "Portefeuille", condition: !loadingBalance && parseFloat(balance) > 0 },
        { href: "/myPages", icon: FaLayerGroup, label: "Mes pages" },
        { href: "/myGroups", icon: FaUsers, label: "Mes groupes" },
        { href: "/games/memoire", icon: FaGamepad, label: "Jeu de mémoire" },
        { href: "/marketing", icon: FaChartBar, label: "Marketing" },
        { href: "/storage/manager", icon: FaWarehouse, label: "Entreposage", condition: user.user_id === 2 },
        { href: "/admin", icon: FaCog, label: "Admin", condition: user.user_id === 2 || user.user_id === 1435 || user.user_id === 2113},
        { href: "/virtualJob", icon: FaKeyboard, label: "Virtual Job", condition: [2, 3, 54, 1435, 1503, 2113].includes(user.user_id) },
        { href: "/games/bingo", icon: FaDiceFive, label: "Bingo" },
        { href: "/jukenet/search", icon: FaMusic, label: "Jukenet search", condition: user.user_id === 2 },
        { href: "/admin/impot", icon: FaFileInvoiceDollar, label: "Impôts", condition: [2, 212, 2113].includes(user.user_id) },
    ];

    // Liens triés par clics
    const sortedLinks = linkClicks.map((href) => links.find((link) => link.href === href)).filter(Boolean);

    return (
        <div className="iconMenuContainer">
            {/* Afficher les liens triés */}
            {sortedLinks.concat(links.filter((link) => !sortedLinks.includes(link))).map(
                ({ href, icon: Icon, label, condition = true }) =>
                    condition && (
                        <LiberiumLink key={href} href={href} passHref>
                            <div className={"iconItem"} onClick={() => recordClick(href)}>
                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                    <Icon size={50} />
                                    {href === '/portefeuille' && parseFloat(balance) > 0 && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '-8px',
                                            right: '-15px',
                                            backgroundColor: '#28a745',
                                            color: 'white',
                                            borderRadius: '12px',
                                            padding: '2px 6px',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            minWidth: '20px',
                                            textAlign: 'center',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {parseFloat(balance).toFixed(0)}$
                                        </div>
                                    )}
                                </div>
                                <p>{label}</p>
                            </div>
                        </LiberiumLink>
                    )
            )}

            <div className={"iconItem"} onClick={deconnect}>
                <FaSignOutAlt size={50} />
                <p>Déconnexion</p>
            </div>
        </div>
    );
};

export { SocialUserApp };